import React from 'react'
import "./meetOurModules.scss"

//Imagens:
import ImgMeetOurModules from "../../../../assets/modules/meetOurModules.png"
import { useTranslation } from 'react-i18next'

function MeetOurModules() {

  const { t } = useTranslation()

  return (
    <div className='container-meet-our-modules'>
      <div className='img-meet-our-modules'>
        <img src={ImgMeetOurModules} alt="" />
      </div>
      <div className='texts-meet-our-modules'>
        <h1>{t("modules.title")}</h1>
        <p>{t("modules.subtitle_desc")}</p>
        <a href="/form" style={{ textDecoration: "none" }}><button id='bnt-meet-our-modules'>{t("buttons.demo_btn_alternative_text_1")}</button></a>
      </div>
    </div>
  )
}

export default MeetOurModules